import { DTOToProduct, productToDTO } from '@/typescript/transformers/product';
import apiFetch from '@/api/apiFetch';
import { t } from '@/translations/i18n';
import type { IProduct } from '@/typescript/interfaces/IProduct';
import type { IProductDTO } from '@/typescript/interfaces/IProductDTO';

async function postUserConfiguration(configuration: IProduct, prestashopUserId: number, prestashopSessionToken: string) {
    const configurationDTO = productToDTO({ ...configuration, prestashopUserId, prestashopSessionToken });

    const response = await apiFetch('/configurations/', {
        method: 'POST',
        body: JSON.stringify(configurationDTO),
    });
    if (!response.ok) {
        throw new Error(t('save_product_error'));
    }
    return DTOToProduct(await response.json());
}

async function putUserConfiguration(configuration: IProduct, prestashopSessionToken: string) {
    const configurationDTO = productToDTO({ ...configuration, prestashopSessionToken });

    const response = await apiFetch(`/configurations/${configuration.id}/`, {
        method: 'PUT',
        body: JSON.stringify(configurationDTO),
    });
    if (!response.ok) {
        throw new Error(t('save_product_error'));
    }
    return DTOToProduct(await response.json());
}

async function getUserConfigurations(prestashopUserId: number) {
    const response = await apiFetch(`/configurations/${prestashopUserId}`);
    if (!response.ok) {
        throw new Error(t('fetch_products_error'));
    }

    const productsDTO = (await response.json()) as IProductDTO[];

    return productsDTO.map((dto) => DTOToProduct(dto));
}

export { postUserConfiguration, putUserConfiguration, getUserConfigurations };
